import moment from 'moment'

export const doubleD = (num: number): string => {
  if(!Number.isInteger(num)) throw new Error('Tade - doublD expects Integer number, but got' + num)
  if(num < -9) return num.toString()
  return num > 9 ?    num.toString() : '0' + num
}

let iterator = 0
const getIterator = () => {
  iterator++
  return doubleD(iterator % 100)
}

export const generateGuid = () => {
  const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
  const x1 = possible.charAt(Math.floor(Math.random() * possible.length))
  const x2 = possible.charAt(Math.floor(Math.random() * possible.length))
  const unix = moment().format('X')
  let d = new Date().getTime()
  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now()
  }
  let uuid = 'xxxxxxxxyxxx'.replace(/[xy]/g, function (c) {
    let r = (d + Math.random() * 16) % 16 | 0
    // eslint-disable-next-line
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
  });
  return unix + uuid + x1 + x2 + getIterator()
}

export const onMobile = () => {
  if(process.env.REACT_APP_CLIENT_DEVICE === 'MOBILE') return true

  const isMobile =
      navigator.userAgent.match(/Android/i)
   || navigator.userAgent.match(/webOS/i)
   || navigator.userAgent.match(/iPhone|iPad|iPod/i)
   || navigator.userAgent.match(/BlackBerry/i)
   || navigator.userAgent.match(/Windows Phone/i)
   || navigator.userAgent.match(/IEMobile/i)
   || navigator.userAgent.match(/Opera Mini/i)
   || window.screen.width <= 600
  return !!isMobile
}



// WEBPACK FOOTER //
// ./src/helpers/index.js